import 'lazysizes';

(() => {
  const iconMap = {
    '56': 'tax_icon_category_smartphone.png',
    '54': 'tax_icon_category_pc.png',
    '5': 'tax_icon_category_tablet.png',
    '68': 'tax_icon_category_camera.png',
    '59': 'tax_icon_category_game_machine.png',
    '367': 'tax_icon_category_smartwatch.png',
    '357': 'tax_icon_category_mp3player.png',
    '379': 'tax_icon_category_ebook_reader.png',
    '77': 'tax_icon_category_books.png',
    '400': 'tax_icon_category_cd_dvd.png',
    '415': 'tax_icon_category_gamesoft.png',
    '2513': 'tax_icon_category_trading_card.png',
    '497': 'tax_icon_category_figure.png',
    '495': 'tax_icon_category_plamodel.png',
    '2552': 'tax_icon_category_minicar.png',
    '438': 'tax_icon_category_rc.png',
    '2606': 'tax_icon_category_model_train.png',
    '4270': 'tax_icon_category_modelgun.png',
    '3498': 'tax_icon_category_music_instrument.png',
    '3510': 'tax_icon_category_piano.png',
    '5289': 'tax_icon_category_furniture.png',
    '431': 'tax_icon_category_consumer_electronics.png',
    '3881': 'tax_icon_category_nursing_care_equipment.png',
    '3995': 'tax_icon_category_kitchenware.png',
    '2876': 'tax_icon_category_power_tools.png',
    '482': 'tax_icon_category_branded.png',
    '476': 'tax_icon_category_watch.png',
    '3754': 'tax_icon_category_wear.png',
    '3737': 'tax_icon_category_sneaker.png',
    '3679': 'tax_icon_category_jewel.png',
    '3320': 'tax_icon_category_ticket.png',
    '3067': 'tax_icon_category_wine.png',
    '5390': 'tax_icon_category_baby.png',
    '3261': 'tax_icon_category_daily_necessities.png',
    '574': 'tax_icon_category_fountain_pen.png',
    '3550': 'tax_icon_category_fishing.png',
    '2338': 'tax_icon_category_golfclub.png',
    '5264': 'tax_icon_category_fitness.png',
    '1936': 'tax_icon_category_roadbike.png',
    '3752': 'tax_icon_category_art.png',
    '3388': 'tax_icon_category_old_coin.png',
    '4015': 'tax_icon_category_bike.png',
    '3078': 'tax_icon_category_car.png',
    '5599': 'tax_icon_category_ship.png',
    '2282': 'tax_icon_category_real_estate.png'
  };

  const baseUrl = `${location.protocol}//${location.host}`;

  const getIconId = el =>
    el.dataset.iconId ||
    [...el.classList].find(c => c.startsWith('id'))?.slice(2);

  const getFileName = id => iconMap[id] || 'tax_icon_default.png';

  const getIconUrl = id => {
    const file = getFileName(id);
    const manifestKey = `hikakaku/images/sprites/tax_icons/${file}`;
    const manifestPath = window.assetManifest?.[manifestKey];
    if (manifestPath) return baseUrl + manifestPath;

    const temp = document.createElement('div');
    temp.className = `taxonomy icon id${id}`;
    temp.style.display = 'none';
    document.body.appendChild(temp);

    const bg = getComputedStyle(temp).backgroundImage;
    document.body.removeChild(temp);

    const match = bg.match(/url\(["']?(.+?)["']?\)/);
    return match?.[1] || `${baseUrl}/assets/${manifestKey}`;
  };

  const loadTaxonomyIcons = () => {
    document
      .querySelectorAll('.taxonomy.icon[data-bg="true"]')
      .forEach(el => {
        if (!el.dataset.bgSet) {
          const id = getIconId(el);
          if (id) {
            el.dataset.bg = getIconUrl(id);
            el.dataset.bgSet = 'true';
          }
        }
      });
  };

  const setupEvents = () => {
    document.querySelectorAll('.js-accordion-headline')
      .forEach(h => h.addEventListener('click', () => setTimeout(loadTaxonomyIcons, 100)));

    const nav = document.getElementById('nav-input');
    if (nav) {
      nav.addEventListener('change', () => {
        if (nav.checked) setTimeout(loadTaxonomyIcons, 100);
      });
    }
  };

  const onLazyUnveil = e => {
    const el = e.target;
    if (el.classList.contains('taxonomy') &&
        el.classList.contains('icon') &&
        !el.style.backgroundImage) {
      const bg = el.dataset.bg;
      if (bg) el.style.backgroundImage = `url(${bg})`;
    }
  };

  const init = () => {
    loadTaxonomyIcons();
    setupEvents();
    document.addEventListener('lazybeforeunveil', onLazyUnveil);
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
